import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import * as Yup from 'yup'
import {InputTextArea} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {SelectOption} from '../../../../../../models/utility.model'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {downloadPDFCheckInOutService} from '../../../../services/booking.service'

const FormRePrintCO: FC = () => {
  const {currentTabItem} = useHoteleria()
  const [showText, setShowText] = useState(false)
  const [reasons, setReasons] = useState<SelectOption[]>([])
  const {getMasterTable} = useCentralServices()

  const isPrintable =
    currentTabItem.objectInfo.ImpresionCheckOut && currentTabItem.objectInfo.ImpresionCheckOut > 0

  const rePrintSchema = Yup.object().shape({
    motivo: Yup.string().required('Motivo es requerido'),
  })

  const {
    register,
    reset,
    handleSubmit,
    // watch,
    setValue,
    control,
    setError,
    formState: {errors},
  } = useForm({
    resolver: yupResolver(rePrintSchema),
  })

  const onSubmit = async (datos: any) => {
    try {
      let dto = {
        reservaCamaId: currentTabItem.idToEdit,
        tipo: 'OUT',
        MotivoReimpresionId: datos?.MotivoReimpresionId,
        Otros: datos?.Otros,
      }
      const response = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `CheckOut-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      reset()
    } catch (error) {
      console.log(error)
    }
  }

  const getReasonsRePrint = async () => {
    const data = await getMasterTable('MotivoReimpresionReserva', true)
    setReasons(data)
  }

  const handleReasonsChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('MotivoReImpresionId', value)
    if (value === 'vsjVgdF@bBw=') {
      setShowText(true)
    } else {
      setValue('Otros', '')
      setShowText(false)
    }
    setError('MotivoReImpresionId', {})
  }

  useEffect(() => {
    getReasonsRePrint()
  }, [])

  return (
    <div className='sdx_form card p-4'>
      <div className='d-flex row'>
        {isPrintable ? (
          <>
            <div className='col-sm-12 col-lg-3'>
              <label>Motivo:</label>
              <Select
                control={control}
                name='MotivoReImpresionId'
                data={reasons}
                errors={errors}
                onChangeValue={handleReasonsChange}
              />
            </div>
            {showText ? (
              <div className='col-sm-12 col-lg-3'>
                <label>Otros:</label>
                <InputTextArea
                  name='Otros'
                  textPlaceholder='Motivo por el cual desea re imprimir?'
                  register={register}
                  errors={errors}
                />
              </div>
            ) : (
              <></>
            )}
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}

            <div className='col-sm-12 col-lg-3 d-flex align-items-center '>
              <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Imprimir
              </button>
            </div>
          </>
        ) : (
          <div>El checkOut aún no ha sido impreso</div>
        )}
      </div>
    </div>
  )
}

export {FormRePrintCO}
